// @Version: 1.0.0
import { Injectable } from '@angular/core';
import { IFileResult, UPLOAD_STATE } from './fileupload.model';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({
   providedIn: 'root'
})
export class FileuploadService {
   public error: boolean = false; 

   private files: IFileResult[] = [];
   private state_: UPLOAD_STATE = UPLOAD_STATE.EMPTY;
   set state (s: UPLOAD_STATE) {
      this.state_ = s;
   }
   get state (): UPLOAD_STATE {
      return this.state_;
   }

   /**
   * format bytes (https://stackoverflow.com/a/18650828)
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
   public formatBytes (bytes: number, decimals = 2): string {
      if (bytes === 0) return '0 Bytes';
   
      const k = 1024;
      const dm = decimals <= 0 ? 0 : decimals;
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return (parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]).replace('\.',',');
   }

   public reset (): void {
      this.files = [];
      this.state_ = UPLOAD_STATE.EMPTY;
      this.error = false;
   }
   
   public initFiles (f: IFileResult[]): void {
      this.files = f;
   }

   public setDisabledState (disabled: boolean) {
      if(disabled) this.state_ = UPLOAD_STATE.DISABLED;
      else this.resetState();
   }
   
   public checkErrorMax (files: File[], maxNumberOfFiles: number, dataUrlSaveLength: number): boolean {
      if (maxNumberOfFiles > 0) {
         this.state_ = (dataUrlSaveLength + files.length) > maxNumberOfFiles ? UPLOAD_STATE.ERROR_MAX : this.state_;
      }
      
      if (this.state_ != UPLOAD_STATE.VALID && this.state_ != UPLOAD_STATE.EMPTY) {
         this.error = true; 
         return true; 
      }

      return false; 
   }

   public checkMaxFileSizeTest (files: File[], maxFilesize: number): boolean {
      const fullUploadSize: number = files
         .map(file => file.size)
         .reduce((first, second) => first + second, 0);

      this.state_ = fullUploadSize > maxFilesize ? UPLOAD_STATE.ERROR_SIZE:this.state_;

      if (this.state_ != UPLOAD_STATE.VALID && this.state_ != UPLOAD_STATE.EMPTY) {
         this.error = true; 
         return true; 
      }

      return false; 
   }

   public checkFileExtensionTest (files: File[], allowedExtensions: string[]): boolean {
      this.state_ = files.filter(file => {
         const fileExtension = file!.name.split('.').pop();
         if (fileExtension) {
            return (allowedExtensions.find(extension => extension.toLowerCase() == fileExtension.toLowerCase()) != undefined);
         }
         return false;
      }).length !== files.length ? UPLOAD_STATE.ERROR_TYPE:this.state_; 
      
      if (this.state_ != UPLOAD_STATE.VALID && this.state_ != UPLOAD_STATE.EMPTY) {
         this.error = true; 
         return true; 
      }
      
      return false; 
   }

   public resetState (): void {
      this.error = false; 
      this.state_ = this.files.length == 0 ? UPLOAD_STATE.EMPTY : UPLOAD_STATE.VALID;
   }


   private renameFile (newName: string, file: File, content: string): Promise<File> {
      return file.arrayBuffer().then(content => {
         const newFile = new File([content],newName,{type: file.type})
         return newFile
      }) 
   }

   public async checkValidFileName (file: File, content: string): Promise<File> {
         const invalidFileName = /[(,), ]/.exec(file.name) || [].length > 0?true:false;
         if(invalidFileName) {
            this.state_ = UPLOAD_STATE.ERROR_INVALID_FILENAME
            return await this.renameFile(file.name.replace(/ - /g,'-').replace(/\(/g,'').replace(/\)/g,'').replace(/ /g,'-'),file, content)
         }
         return file
   }
}
